import { RootEpic } from 'typesafe-actions';

import { createGetEpic, createPaginatedGetEpic } from '../utils';
import { getDeployByHashAsync, getPaginatedDeploysAsync } from './actions';

export const loadDeploys: RootEpic = (
  action$,
  state$,
  { getPaginatedDeploysSubscription }
) =>
  createPaginatedGetEpic(
    action$,
    getPaginatedDeploysAsync,
    getPaginatedDeploysSubscription
  );

export const loadDeploy: RootEpic = (
  action$,
  state$,
  { getDeploySubscription }
) => createGetEpic(action$, getDeployByHashAsync, getDeploySubscription);
